<template>
  <div>
    <slot name="body"></slot>

    <div class="approvals">
      <ul class="col-md-12">
        <li v-for="user in approvalUsersData" :key="user.id">
          {{ user.FirstName }} {{ user.LastName }}
        </li>
      </ul>
      <br style="clear: both;" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: Object
  },

  data() {
    return {
      approvalUsersData: []
    }
  },

  methods: {
    getApprovalUsers() {
      this.api.get(this.api.$.evedpaycard.approvalUsersForEnvelope, {
        params: {
          envelopeId: this.model.Id
        }
      })
      .then(response => {
        this.approvalUsersData = response.data.filter(user => user.IsCurrentAction === true)
      })
      .catch(error => {
        console.error('There was a problem with the approval users request:', error)
      })
    }
  },

  created() {
    this.getApprovalUsers()
  }
}
</script>

<style scoped lang='scss'>
ul {
  list-style-type: none;
}

.approvals {
  height: 90px;
  overflow: auto;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/attachments-details.vue